export default "__VITE_ASSET__6Ku4uZKk__"